<template>
    <div v-if="isIdrDropdown" class="dropdown idr-dropdown">
        <a href="#" class="idr-chevron-trigger p-2" role="button" data-bs-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <i :class="icon" :style="iconStyle"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-end idr-panel">
            <div class="idr-panel-header">Run sub-pipeline</div>

            <a v-for="btn in list" :key="btn.id"
               class="idr-job-card" @click.prevent="btn.onClick">
                <div class="idr-icon-box" :class="btn.colorClass">
                    <i :class="btn.icon" v-if="btn.icon"></i>
                </div>
                <div class="idr-card-body">
                    <div class="idr-card-title">{{ btn.name }}</div>
                    <div class="idr-card-sub">{{ btn.description }}</div>
                </div>
            </a>
        </div>
    </div>

    <div v-else-if="list.length > 0" class="dropdown">
        <a href="#" class="dropdown-ellipses dropdown-toggle p-2" role="button" data-bs-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <i :class="icon" :style="iconStyle"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-end">
            <a v-for="btn in list" :key="btn.id" class="dropdown-item" @click="btn.onClick">
                <div class="d-flex justify-content-start align-items-center">
                    <div class="d-flex justify-content-center align-items-center"
                        :style="{ width: '20px', marginRight: '0.6rem' }">
                        <i :class="[btn.icon]" v-if="btn.icon"></i>
                    </div>
                    {{ btn.name }}
                </div>
            </a>
        </div>
    </div>
</template>

<script>
export default ({
    name: "ActionDropdown",
    props: {
        btnList: {
            type: Array,
            default: function () { return [] }
        },
        icon: {
            type: Array,
            default: function () { return ['fa', 'fa-ellipsis-v'] }
        },
        iconStyle: {
            type: Object,
            default: function () { return {} }
        },
        isIdrDropdown: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        list() {
            return this.btnList.filter((value) => value.visible)
        }
    }
})
</script>

<style scoped>
.dropdown-ellipses {
    color: #6E84A3 !important;
    font-size: 1.1625rem !important;
}
.dropdown-ellipses:hover { color: #000000 !important; }
.dropdown-item {
    color: #6E84A3 !important;
    cursor: pointer;
    padding-left: 1.1rem !important;
}

.dropdown-menu {
    margin-top: 6px !important; /* Adjust the pixel value as needed */
}
.dropdown-item:hover {
    background-color: #efefef;
    color: #000000;
}

/* IDR dropdown trigger */
.idr-chevron-trigger {
    display: flex;
    align-items: center;
    padding: 0 2px;
    color: inherit;
    text-decoration: none;
}

/* Panel */
.idr-panel {
    padding: 0;
    border-radius: 10px;
    border: 0.5px solid rgba(0, 0, 0, 0.15);
    min-width: 300px;
    overflow: scroll;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}
.idr-panel-header {
    padding: 9px 14px 7px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: #6c757d;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);
}

/* Job cards */
.idr-job-card {
    display: flex;
    align-items: flex-start;
    gap: 11px;
    padding: 11px 14px;
    cursor: pointer;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);
    text-decoration: none;
    transition: background 0.1s;
}
.idr-job-card:last-of-type { border-bottom: none; }
.idr-job-card:hover { background-color: #f8f9fa; }

.idr-icon-box {
    width: 30px;
    height: 30px;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
    margin-top: 1px;
}
.idr-icon-box.blue   { background: #E6F1FB; color: #185FA5; }
.idr-icon-box.teal   { background: #E1F5EE; color: #0F6E56; }
.idr-icon-box.purple { background: #EEEDFE; color: #534AB7; }

.idr-card-body { display: flex; flex-direction: column; gap: 2px; }
.idr-card-title { font-size: 13px; font-weight: 500; color: #212529; }
.idr-card-sub   { font-size: 12px; color: #6c757d; line-height: 1.4; }

.idr-pills { display: flex; flex-wrap: wrap; gap: 3px; margin-top: 5px; }
.idr-pill {
    font-size: 11px;
    padding: 1px 7px;
    border-radius: 99px;
    border: 0.5px solid #dee2e6;
    color: #6c757d;
    background: #f8f9fa;
}

/* Run all row */
.idr-divider { height: 0.5px; background: rgba(0, 0, 0, 0.08); }
.idr-run-all-row {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 10px 14px;
    cursor: pointer;
    text-decoration: none;
    transition: background 0.1s;
}
.idr-run-all-row:hover { background-color: #f8f9fa; }
.idr-run-all-icon {
    width: 30px; height: 30px;
    border-radius: 7px;
    display: flex; align-items: center; justify-content: center;
    font-size: 13px;
    flex-shrink: 0;
    background: rgba(0, 0, 0, 0.05);
    color: #6c757d;
}
.idr-run-all-label { font-size: 13px; font-weight: 500; color: #212529; }
.idr-run-all-sub   { font-size: 12px; color: #6c757d; }
</style>

<style lang="scss">
@use '../theme/scss/_user-variables.scss' as *;

body.dark-mode {
    .dropdown-ellipses { color: $dark-text-primary !important; }
    .dropdown-ellipses:hover { color: $dark-text-secondary !important; }
    .dropdown-item { color: $dark-text-secondary !important; }
    .dropdown-item:hover {
        background-color: $dark-hover-bg !important;
        color: $dark-text-primary !important;
    }
    .dropdown-menu { background-color: $dark-card-bg !important; }

    .idr-panel { border-color: rgba(255, 255, 255, 0.12); }
    .idr-panel-header { color: $dark-text-secondary; border-color: rgba(255, 255, 255, 0.08); }
    .idr-job-card { border-color: rgba(255, 255, 255, 0.06); }
    .idr-job-card:hover { background-color: $dark-hover-bg; }
    .idr-card-title { color: $dark-text-primary; }
    .idr-card-sub   { color: $dark-text-secondary; }
    .idr-pill { background: $dark-hover-bg; border-color: rgba(255,255,255,0.12); color: $dark-text-secondary; }
    .idr-divider { background: rgba(255, 255, 255, 0.08); }
    .idr-run-all-row:hover { background-color: $dark-hover-bg; }
    .idr-run-all-label { color: $dark-text-primary; }
    .idr-run-all-sub   { color: $dark-text-secondary; }
    .idr-run-all-icon  { background: rgba(255,255,255,0.06); color: $dark-text-secondary; }
    .idr-icon-box.blue   { background: #185ea51d; color: #006fdd; }
    .idr-icon-box.teal   { background: #0f6e561b; color: #009c75; }
    .idr-icon-box.purple { background: #534ab71f; color: #5243f2; }
}
</style>